<template>
  <progress class="progress w-full" :value="progress" max="10"></progress>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
};
</script>
